import WxContentsDispatcher from "./WxContentsDispatcher";
import { useSetRecoilState } from "recoil";
import { sigmetUnreadState } from "../../../store/SigmetUnreadPositionState";

function SigmetDispatcher(props) {
  const setSigmetUnread = useSetRecoilState(sigmetUnreadState);

  props.contents.setUnreadDispatcher((unreadPosition)=>{
    setSigmetUnread(unreadPosition);
  });

  return <WxContentsDispatcher {...props}/>
}

export default SigmetDispatcher;